import { createSelector } from "reselect"

import { get } from "common/utils/get"
import { homeRedirectUrlSelector } from "../branding/selectors"
import urlPrefixSelector from "./prefixSelector"
import { getBackToSearchUrl } from "../../../booking/services/states/reducer"

export const pageNameSelector = state => state.page.get("name")

export const prefixedHomeRedirectUrlSelector = createSelector(
  [urlPrefixSelector, homeRedirectUrlSelector],
  (urlPrefix, homeRedirectUrl) => `${urlPrefix}${homeRedirectUrl}`,
)

export const navBarLogoUrlSelector = createSelector(
  state => state,
  pageNameSelector,
  prefixedHomeRedirectUrlSelector,
  (state, pageName, prefixedHomeRedirectUrl) => {
    let backToSearchUrl
    if (pageName === "booking") {
      backToSearchUrl = getBackToSearchUrl(state)
    }
    if (!backToSearchUrl) {
      return prefixedHomeRedirectUrl
    }
    if (typeof window !== "undefined") {
      const anchorEl = document.createElement("a")
      anchorEl.href = backToSearchUrl
      const backToSearchUrlOrigin = get("origin", anchorEl)
      if (window.location.origin === backToSearchUrlOrigin) {
        return backToSearchUrl
      }
    }
    return prefixedHomeRedirectUrl
  },
)
